module.exports = __webpack_public_path__ + "img/Avatar-61.f8f1c091.svg";